import React from "react";
import { formatDate } from "../../../helpers/helpers.jsx";
import { text01, text02, text03, text04, text05, postTitle } from "./Post06.json";

const BlogPost = ({ lang }) => {
  return (
    <div className="postContainer">
      <div className="postHeader">
        <h1 className="postTitle">{postTitle[lang]}</h1>
        <span className="postedBy">{formatDate(lang, "2025-12-04")}</span>
      </div>
      <div className="postText postText-center">
        <div className="postImageContainer-50">
          <img src="images/A5pozvanka2025.jpg" alt="Musica Pro Sancta Cecilia" />
        </div>
        <p style={{ textAlign: "center" }}>
          {text01[lang]} <br />
          <br /> {text02[lang]} <br />
          <br /> {text03[lang]} <br />
          <br /> {text04[lang]}  <br />
          <br /> {text05[lang]}  <br />
          <a href="https://www.youtube.com/watch?v=Ks6t14y87D4" target="_blank">https://www.youtube.com/watch?v=Ks6t14y87D4</a>
          <br />
          <a href="https://www.youtube.com/watch?v=RYjH_l4H3RA" target="_blank">https://www.youtube.com/watch?v=RYjH_l4H3RA</a>
          <br />
        </p>

      </div>
    </div>
  );
};

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/Home/post06/Post06.jsx